module.exports = __webpack_public_path__ + "img/marker-pin-05.2db7fb8b.svg";